import BadgeDropdown from "../../../../components/badgeDropdown/badgeDropdown";
import { useAuthStatusDropdown } from "../../../../hooks/useAuthStatusDropdown";
import WarningIcon from "../../../../svg/warningIcon";

interface StatusErrorProps {
  title: string;
  showDropdown?: boolean;
}

const StatusError = ({ title, showDropdown = true }: StatusErrorProps) => {
  const { selectedAuthStatusBadge, handleAuthStatusChange, authStatusOptions } =
    useAuthStatusDropdown();

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 p-8">
      <div className="flex flex-col items-center gap-2">
        <WarningIcon height="32" width="32" />
        <div className="text-center">{title}</div>
      </div>
      {showDropdown && (
        <div className="flex items-center gap-2">
          <div className="text-sm font-normal text-primaryGray-1">
            Select Auth Status
          </div>
          <BadgeDropdown
            selectedBadge={selectedAuthStatusBadge}
            badgeList={authStatusOptions}
            onClick={handleAuthStatusChange}
          />
        </div>
      )}
    </div>
  );
};

export default StatusError;
